export default __webpack_public_path__ + "media/31f054e8a8f81ec0be6e436af9f9937bad7b6a8bd3f58451425fec202a55e9ef.svg";